import { render, staticRenderFns } from "./TotalDistHsrChart.vue?vue&type=template&id=052f8543"
import script from "./TotalDistHsrChart.vue?vue&type=script&lang=js"
export * from "./TotalDistHsrChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports